module.exports = __webpack_public_path__ + "static/media/she_is_connected_sign.bfeb1666.png";